import React from 'react';
import Icon from '../../../components/AppIcon';

const ModuleQAQCTracking = ({ qaqcData }) => {
  if (!qaqcData) {
    return (
      <div className="bg-card rounded-xl border border-border p-5 h-full">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Shield" size={16} color="var(--color-primary)" />
          </div>
          <h3 className="text-base font-semibold text-foreground">QA/QC Tracking</h3>
        </div>
        <p className="text-sm text-muted-foreground">No QA/QC data available</p>
      </div>
    );
  }

  const passRate = qaqcData?.totalInspections > 0 
    ? ((qaqcData?.passed / qaqcData?.totalInspections) * 100)?.toFixed(1)
    : 0;

  const getPassRateColor = (rate) => {
    if (rate >= 95) return 'var(--color-success)';
    if (rate >= 80) return 'var(--color-warning)';
    return 'var(--color-error)';
  };

  return (
    <div className="bg-card rounded-xl border border-border p-5 h-full">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Shield" size={16} color="var(--color-primary)" />
        </div>
        <h3 className="text-base font-semibold text-foreground">QA/QC Tracking</h3>
      </div>

      {/* Pass Rate Circle */}
      <div className="flex items-center justify-center mb-4">
        <div className="relative">
          <div 
            className="w-24 h-24 rounded-full flex items-center justify-center"
            style={{ backgroundColor: `${getPassRateColor(passRate)}20` }}
          >
            <div className="text-center">
              <p className="text-2xl font-bold" style={{ color: getPassRateColor(passRate) }}>
                {passRate}%
              </p>
              <p className="text-xs text-muted-foreground">Pass Rate</p>
            </div>
          </div>
        </div>
      </div>

      {/* Inspection Stats */}
      <div className="space-y-2 mb-4">
        <div className="flex items-center justify-between p-2 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-2">
            <Icon name="ClipboardCheck" size={14} color="var(--color-primary)" />
            <span className="text-xs text-foreground">Total Inspections</span>
          </div>
          <span className="text-sm font-semibold text-foreground">{qaqcData?.totalInspections || 0}</span>
        </div>
        
        <div className="flex items-center justify-between p-2 bg-success/10 rounded-lg">
          <div className="flex items-center gap-2">
            <Icon name="CheckCircle" size={14} color="var(--color-success)" />
            <span className="text-xs text-foreground">Passed</span>
          </div>
          <span className="text-sm font-semibold text-success">{qaqcData?.passed || 0}</span>
        </div>
        
        <div className="flex items-center justify-between p-2 bg-error/10 rounded-lg">
          <div className="flex items-center gap-2">
            <Icon name="XCircle" size={14} color="var(--color-error)" />
            <span className="text-xs text-foreground">Failed</span>
          </div>
          <span className="text-sm font-semibold text-error">{qaqcData?.failed || 0}</span>
        </div>
        
        <div className="flex items-center justify-between p-2 bg-warning/10 rounded-lg">
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={14} color="var(--color-warning)" />
            <span className="text-xs text-foreground">Pending</span>
          </div>
          <span className="text-sm font-semibold text-warning">{qaqcData?.pending || 0}</span>
        </div>
      </div>

      {/* Critical Issues Alert */}
      {qaqcData?.criticalIssues > 0 && (
        <div className="p-3 bg-error/10 rounded-lg border border-error/20">
          <div className="flex items-center gap-2">
            <Icon name="AlertTriangle" size={16} color="var(--color-error)" />
            <div>
              <p className="text-xs font-medium text-error">
                {qaqcData?.criticalIssues} Critical Issue{qaqcData?.criticalIssues > 1 ? 's' : ''}
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">Requires immediate attention</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModuleQAQCTracking;